import { namespacedClassnames, TicketPriority } from '../../common';
import * as React from 'react';
export var PriorityLabelType;
(function (PriorityLabelType) {
    PriorityLabelType[PriorityLabelType["REGULAR"] = 1] = "REGULAR";
    PriorityLabelType[PriorityLabelType["REGULARICON"] = 2] = "REGULARICON";
    PriorityLabelType[PriorityLabelType["SMALL"] = 3] = "SMALL";
})(PriorityLabelType || (PriorityLabelType = {}));
export var priorityLabelKey = 'priority-label';
export var PriorityLabel = function (_a) {
    var priority = _a.priority, className = _a.className, toggled = _a.toggled, onToggle = _a.onToggle, type = _a.type, getPriorityText = _a.getPriorityText;
    var selectedPriorityName = TicketPriority[priority].toLowerCase();
    var text = getPriorityText ? getPriorityText(priority) : selectedPriorityName;
    var labelType = type
        ? PriorityLabelType[type].toLowerCase() : PriorityLabelType[PriorityLabelType.REGULAR].toLowerCase();
    var filled = toggled !== false;
    var classNames = namespacedClassnames(priorityLabelKey, className, selectedPriorityName, labelType, { filled: filled, clickable: !!onToggle });
    var localOnToggle = onToggle ? function (e) { return onToggle(priority, e); } : undefined;
    return React.createElement("div", { "data-priority": priority, className: classNames, onClick: localOnToggle }, text);
};
//# sourceMappingURL=priority-label.js.map